/**
 * Shared Swiper config.
 */
import { SwiperInit } from './swiper-init';

document.addEventListener( 'DOMContentLoaded', () => {
	const containers = document.querySelectorAll( '.swiper' );

	// Return early, and often.
	if ( ! containers.length ) {
		return;
	}

	// Loop through all sliders and assign Swiper object.
	containers.forEach( ( element ) => {
		// Pass options
		let options = {};

		try {
			options = JSON.parse( element.dataset.swiper );
		} catch ( e ) {
			// eslint-disable-next-line no-console
			console.error( e );
			return;
		}

		// Slider 🚀
		SwiperInit( element, options );
	} );

	// Movie slide modal triggers — handles dynamically-queried slides that have
	// no jormi-blocks/slide inner block (so slide/view.js is not loaded).
	const modalBtn   = document.querySelector( '.wp-block-jormi-blocks-modal button' );
	const modalVideo = document.querySelector( '.wp-block-jormi-blocks-modal video' );
	const modalTitle = document.querySelector( '.jormi-modal__header h2' );

	document.querySelectorAll( '.video-container button' ).forEach( ( btn ) => {
		btn.addEventListener( 'click', () => {
			const target = btn.dataset.hsOverlay;

			if ( modalBtn )   modalBtn.dataset.hsOverlay = target;
			if ( modalVideo ) {
				modalVideo.src    = btn.dataset.url    || '';
				modalVideo.poster = btn.dataset.poster || '';
			}
			if ( modalTitle ) {
				const client  = btn.dataset.client || '';
				const heading = btn.dataset.title  || '';
				modalTitle.innerHTML = client
					? client + ( heading ? ' <em>' + heading + '</em>' : '' )
					: heading;
			}

			// Play video as soon as Preline opens the modal.
			const modalEl = target ? document.querySelector( target ) : null;
			if ( modalEl && modalVideo ) {
				modalEl.addEventListener( 'open.hs.overlay', function playOnOpen() {
					modalEl.removeEventListener( 'open.hs.overlay', playOnOpen );
					modalVideo.play().catch( () => {} );
				} );
			}
		} );
	} );
} );


